module.exports = __webpack_public_path__ + "img/5C2E0C_C36924_9F4F14_834114-256px.f9e5790e.png";